import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';
import { hasuraClient } from '../utils/graphqlClient';
import { UPDATE_BONUS_REVENUE_RULE_TEAMS_MUTATION } from '../graphql/mutations/primYonetimi';

const CIRO_KANALI_LABEL = {
  SATIS_CIROSU: 'Satış Cirosu',
  ONAY_SONRASI_CIROSU: 'Onay Sonrası Cirosu',
  PROJE_YAZIM_CIROSU: 'Proje Yazım Cirosu',
};

const parseTeamIds = (formData) =>
  Array.isArray(formData.team_ids)
    ? formData.team_ids
        .map((v) => (typeof v === 'string' ? parseInt(v, 10) : v))
        .filter((v) => Number.isFinite(v))
    : [];

// Bir kural birden çok ekibe atanabilir; junction table bonus_revenue_rule_teams.
// transformFormData scalar alanları döner; team_ids onSuccess callback ile
// delete+insert pattern üzerinden ayrı bir mutation ile senkronlanır.
const useBonusRevenueRules = () => {
  const { user } = useAuth();

  const dynamicHook = useDynamicEntity({
    entityType: 'bonusRevenueRules',
    gqlEntityKey: 'bonus_revenue_rules',
    queryName: 'GET_BONUS_REVENUE_RULES_QUERY',
    createMutation: 'CREATE_BONUS_REVENUE_RULE_MUTATION',
    updateMutation: 'UPDATE_BONUS_REVENUE_RULE_MUTATION',
    deleteMutation: 'DELETE_BONUS_REVENUE_RULE_MUTATION',
    transformData: (row) => ({
      ...row,
      company_name: row.company?.name || `Company ${row.company_id}`,
      team_name: (row.rule_teams || [])
        .map((rt) => rt.team?.name)
        .filter(Boolean)
        .join(', ') || '—',
      team_ids: (row.rule_teams || []).map((rt) => rt.team_id),
      ciro_kanali: row.ciro_kanali,
      ciro_kanali_label: CIRO_KANALI_LABEL[row.ciro_kanali] || row.ciro_kanali,
      operation: row.operation,
      aciklama: row.aciklama,
      companyId: row.company_id,
    }),
    transformFormData: (formData) => ({
      ciro_kanali: formData.ciro_kanali,
      operation: (formData.operation || '').toUpperCase().replace(/\s+/g, ''),
      aciklama: formData.aciklama || null,
    }),
    onSuccess: async (action, entity, formData) => {
      const ruleId = entity?.id;
      if (!ruleId) return;
      const teamIds = parseTeamIds(formData);
      // Hem create hem update sonrası delete+insert pattern.
      // Yeni kayıt için delete no-op olur.
      await hasuraClient.mutate(UPDATE_BONUS_REVENUE_RULE_TEAMS_MUTATION, {
        ruleId,
        objects: teamIds.map((team_id) => ({ bonus_revenue_rule_id: ruleId, team_id })),
      });
    },
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useBonusRevenueRules };
